module.exports = __webpack_public_path__ + "6b979964e304492486d9241dd37015f7.pdf";